module.exports = __webpack_public_path__ + "static/media/mouthFunnel.d61dd0f3.obj";